import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=c52688dc&scoped=true"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"
import style0 from "./Opinion.vue?vue&type=style&index=0&id=c52688dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52688dc",
  null
  
)

export default component.exports